export class Device {

    constructor(
        public lat = '1',
        public lng = '1',
        public app_version = 'v1',
        public platform = '3')
    {}

}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/model/device.ts